@if (ref().created) {
  <span class="gutter"
        [class.deleted]="deleted()">
    @if (ref().origin && !authors().length) {
      <a class="origin tag" [routerLink]="['/tag', ref().origin]">{{ ref().origin }}</a>
    }
    @if (authorExts$() | async; as xs) {
      @for (x of xs; track x.tag + x.origin) {
        <a class="user tag"
           [title]="formatAuthor(x.tag + x.origin)"
           [routerLink]="['/tag', x.tag + x.origin]"
           [appTitle]="x">{{ x.name || formatAuthor(x.tag) }}</a>
      }
    } @else {
      @for (t of authors(); track t) {
        <a class="user tag"
           [title]="formatAuthor(t)"
           [routerLink]="['/tag', t]">{{ formatAuthor(t) }}</a>
      }
    }
    <span class="timestamp" [title]="ref().modified?.toISO()">{{ ref().modified | relative }}</span>
    &nbsp;|&nbsp;
  </span>
} @else if (loading()) {
  <div class="loading-container"><app-loading /></div>
}
<span class="message"
      [class.bubble]="focused()"
      [class.focused]="focused()"
      [class.deleted]="deleted()"
      [class.sending]="!ref().created"
      (pointerenter)="setHovering(true)"
      (pointerleave)="setHovering(false)">
  <div class="content" [class.has-title]="clickableLink() || title() && !focused()">
    @if (tagLink()) {
      <app-nav [url]="ref().url" [text]="title()" />
    } @else if (clickableLink() && (title() && !focused() || !media())) {
      <app-nav [url]="ref().url" [text]="title()" [external]="true" />
    } @else {
      <span>{{ title() }}</span>
    }
    @if (focused() && bareRef()?.comment) {
      <app-md [origin]="ref().origin!"
              [text]="bareRef()!.comment!"
              [plugins]="bareRef()!.tags!" />
    }
    <app-viewer [ref]="noComment()" />
  </div>
  @if (ref().created) {
    <div class="actions" [style.pointer-events]="allowActions() ? 'auto' : 'none'">
      @if (threads()) {
        <a  [routerLink]="['/ref', ref().url, 'thread']"
            [queryParams]="{ origin: nonLocalOrigin() }"
            (click)="saveRef()"
            i18n>sidebar</a>
      } @else if (comments()) {
        <a  [routerLink]="['/ref', ref().url, 'comments']"
            [queryParams]="{ origin: nonLocalOrigin() }"
            (click)="saveRef()"
            i18n>{comments(), plural, =1 {1&thinsp;comment} other {{{ comments() }}&thinsp;comments}}</a>
      } @else if (chatroom()) {
        <a [routerLink]="['/ref', ref().url]"
           [queryParams]="{ origin: nonLocalOrigin() }"
           (click)="saveRef()"
           i18n>sidebar</a>
      } @else {
        <a [routerLink]="['/ref', ref().url]"
           [queryParams]="{ origin: nonLocalOrigin() }"
           (click)="saveRef()"
           i18n>permalink</a>
      }
      @if (store.account.mod || taggingAccess()) {
        <app-confirm-action
                            [class.force-delete]="deleteAccess()"
                            [action]="store.hotkey() ? forceDelete$ : delete$" i18n>delete</app-confirm-action>
      }
      @if (taggingAccess()) {
        <app-inline-tag [action]="tag$" [tags]="ref().tags" i18n>tag</app-inline-tag>
      }
      @if (!ref().origin && store.account.mod && !approved() && !locked()) {
        <a class="fake-link" (click)="approve()" i18n>approve</a>
      }
      @if (store.account.mod && approved()) {
        <span class="approved icon" i18n-title title="Moderated" i18n>✔️</span>
      }
    </div>
  }
</span>
@for (e of serverError(); track e) {
  <span><!-- Unexpected Error --></span>
  <div class="error">{{ e }}</div>
}
